<template>
    <div>
        <rd-popup :visibility="popupVisible" :title="$t('add.title')">
            <dx-validation-group :ref="`validationGroup`" @initialized="validationGroupInitialized">
                <rd-popup-content>
                    <div class="row">
                        <rd-column :size="$columns.TwelveOnLg">
                            <rd-form-group :label="$t('add.label.role')">
                                <dx-lookup :search-enabled="true"
                                           :data-source="getRolesDataSource"
                                           display-expr="Text"
                                           value-expr="Value"
                                           :closeOnOutsideClick="true"
                                           v-model="RoleId">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-lookup>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.NineOnLg">
                            <rd-form-group :label="$t('add.label.departmentName')" :key="departmentComponentKey">
                                <dx-tag-box :search-enabled="true"
                                            :data-source="getPzzDepartments"
                                            display-expr="Text"
                                            value-expr="Value"
                                            :disabled="departmentsAll"
                                            v-model="DepartmentsIds">
                                    <dx-validator>
                                        <dx-required-rule v-if="!departmentsAll" :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-tag-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.ThreeOnLg">
                            <rd-form-group :label="$t('add.label.all')" input-type="checkbox" class="mt-3">
                                <dx-check-box v-model="departmentsAll"
                                              @value-changed="departmentsChangeTagBoxAttr">
                                </dx-check-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.NineOnLg">
                            <rd-form-group :label="$t('add.label.orderTypeName')" :key="orderComponentKey">
                                <dx-tag-box :search-enabled="true"
                                            :data-source="getOrderTypes"
                                            display-expr="Text"
                                            value-expr="Value"
                                            :closeOnOutsideClick="true"
                                            :disabled="orderTypesAll"
                                            v-model="OrderTypesIds">
                                    <dx-validator>
                                        <dx-required-rule v-if="!orderTypesAll" :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-tag-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.ThreeOnLg">
                            <rd-form-group :label="$t('add.label.all')" input-type="checkbox" class="mt-3">
                                <dx-check-box v-model="orderTypesAll"
                                              @value-changed="orderTypesChangeTagBoxAttr">
                                </dx-check-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg">
                            <rd-form-group :label="$t('add.label.accessType')">
                                <dx-select-box :data-source="getAccessTypes"
                                               display-expr="Text"
                                               value-expr="Value"
                                               v-model="DepartmentAccessType">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-select-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg" v-if="isAccessReadOrEdit">
                            <rd-form-group :label="$t('add.label.additionalVisibility')">
                                <dx-select-box :data-source="getAdditionalVisibilities"
                                               display-expr="Text"
                                               value-expr="Value"
                                               v-model="AdditionalVisibility"
                                               :show-clear-button="true"
                                               @value-changed="additionalVisibilityValueChanged">
                                </dx-select-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg" v-if="isUserVisibility">
                            <rd-form-group :label="$t('add.label.userVisibility')">
                                <dx-lookup :search-enabled="true"
                                           :data-source="getUserVisibilityDataSource"
                                           display-expr="Text"
                                           value-expr="Value"
                                           :show-clear-button="true"
                                           :closeOnOutsideClick="true"
                                           v-model="UserVisibilityId">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-lookup>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg" v-if="isRoleVisibility">
                            <rd-form-group :label="$t('add.label.roleVisibility')">
                                <dx-lookup :search-enabled="true"
                                           :data-source="getRoleVisibilityDataSource"
                                           display-expr="Text"
                                           value-expr="Value"
                                           :show-clear-button="true"
                                           :closeOnOutsideClick="true"
                                           v-model="RoleVisibilityId">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-lookup>
                            </rd-form-group>
                        </rd-column>
                    </div>
                </rd-popup-content>
                <rd-popup-actions>
                    <dx-button :use-submit-behavior="false"
                               styling-mode="text"
                               type="normal"
                               :text="$t('buttons.cancel')"
                               @click="closePopup">
                    </dx-button>
                    <dx-button :use-submit-behavior="true"
                               type="default"
                               class="ml-1"
                               :text="$t('buttons.save')"
                               @click="closePopupOnSave">
                    </dx-button>
                </rd-popup-actions>
            </dx-validation-group>
        </rd-popup>
    </div>
</template>

<script>
    // @ is an alias to /src
    import DxButton from 'devextreme-vue/button';
    import {
        DxRequiredRule,
        DxValidator
    } from 'devextreme-vue/validator';
    import DxSelectBox from 'devextreme-vue/select-box';
    import { DxLookup } from 'devextreme-vue/lookup';
    import DxValidationGroup from 'devextreme-vue/validation-group';
    import DxTagBox from 'devextreme-vue/tag-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';

    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    const name = "administrationStores/dictionariesStores/pzzDepartmentUsersStores/addRoleStore";

    export default {
        name: 'pzzDepartmentUsersAdd',
        data() {
            return {
                popupVisible: false,
                pageSizes: [5, 10, 15],
                orderTypesAll: false,
                departmentsAll: false,
                departmentComponentKey: 0,
                orderComponentKey: 0
            }
        },
        computed: {
            ...mapGetters(name, ['getForm', 'getPzzDepartments', 'getRolesDataSource', 'getOrderTypes', 'getUserVisibilityDataSource', 'getRoleVisibilityDataSource', 'getAccessTypes', 'getAdditionalVisibilities']),
            ...mapFields(name, [
                'addForm.RoleId',
                'addForm.DepartmentsIds',
                'addForm.OrderTypesIds',
                'addForm.DepartmentAccessType',
                'addForm.AdditionalVisibility',
                'addForm.UserVisibilityId',
                'addForm.RoleVisibilityId',
            ]),

            isAccessReadOrEdit: function () {
                return this.DepartmentAccessType === 1 || this.DepartmentAccessType === 2;
            },
            isUserVisibility: function () {
                return this.AdditionalVisibility === 1;
            },
            isRoleVisibility: function () {
                return this.AdditionalVisibility === 2;
            }
        },
        methods: {
            ...mapActions(name, ['setDefaultValues', 'validateDepartmentRoleAccess', 'addDepartmentRoleAccess']),
            ...mapMutations(name, ['resetForm', 'clearDepartments', 'clearOrderTypes']),
            closePopup: function () {
                this.popupVisible = false;
                this.resetForm();
                this.orderTypesAll = false;
                this.departmentsAll = false;
            },
            additionalVisibilityValueChanged: function (e) {
                this.UserVisibilityId = null;
                this.RoleVisibilityId = null;
            },
            accessTypeValueChanged: function (e) {
                this.AdditionalVisibility = null;
            },
            closePopupOnSave: function (e) {
                let validateResult = this.$refs["validationGroup"].instance.validate()
                if (validateResult.isValid) {
                    this.$emit('closeAdd');
                    this.addDepartmentRoleAccess().then(() => {
                        this.popupVisible = false;
                        this.resetForm();
                        this.orderTypesAll = false;
                        this.departmentsAll = false;
                        this.$emit('added');
                    });
                }
            },
            departmentsChangeTagBoxAttr: function (e) {
                if (e.value) {
                    this.clearDepartments();
                }
            },
            orderTypesChangeTagBoxAttr: function (e) {
                if (e.value) {
                    this.clearOrderTypes();
                }
            },
            forceRerenderDepartmentComponent() {
                this.departmentComponentKey += 1;
            },
            forceRerenderOrderComponent() {
                this.orderComponentKey += 1;
            },
            show() {
                this.popupVisible = true;
            },
            validationGroupInitialized(e) {
                let localthis = this;
                setTimeout(function () {
                    localthis.$refs["validationGroup"].instance.validate();
                }, 0);
            },
        },
        watch: {
            departmentsAll: function (newVal, oldVal) {
                this.forceRerenderDepartmentComponent();
            },
            orderTypesAll: function (newVal, oldVal) {
                this.forceRerenderOrderComponent();
            }
        },
        mounted() {
            this.setDefaultValues();
        },
        components: {
            DxButton,
            DxValidationGroup,
            DxTagBox,
            DxCheckBox,
            DxValidator,
            DxRequiredRule,
            DxSelectBox,
            DxLookup
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
